import React   from 'react' ;
import PageCh13_t1 from './pageCh13_t1'; 
const   PageCh13 = ()=>{
     
       
    return (
      <>  <hr/> 
      <h1 className="m-2" >PageCh13 (chapter 13)</h1>
       <PageCh13_t1 />  
        
      </>
    )
     
} 
export default PageCh13
